module.exports = __webpack_public_path__ + "static/media/mm3.8056dec3.png";